<template>
    <div>
        <Header :data_status="data_status"></Header>
        <div v-if="data.booking">
            <div class="card-block" v-show="data_status != 'loading'">
                <div class="inline" justify="between" valign="center">
                    <h1>Запрос на букинг #{{ $route.params.id }}<router-link class="button _free _second" to="/booking_request">К списку</router-link></h1>
                    <div class="inline" :status="status_request">
                        <div class="button _free _second" @click="showPopup({popup: 'rollback', text: data.id})" v-if="data.rollback_possible">Откат</div>

                        <div v-if="data.booking.approved" class="text-accept">Подтверждено</div>
                        <div v-else class="inline">
                            <div class="button _free _accept" @click="approve()">Принять</div>
                            <div v-if="data.booking.rejected"  class="text-decline">Отказано</div>
                            <div v-else class="button _free _decline" @click="reject()">Отклонить</div>
                        </div>
                    </div>
                </div>
                <div class="tabs">
                    <router-link to="contacts">Контакты</router-link>
                    <router-link to="info">Информация</router-link>
                    <router-link to="shedule">Расписание</router-link>
                    <router-link to="price">Цены</router-link>
                </div>

                <router-view :class="{'not-allowed': data.booking.approved}" :loading="status_request" :data.sync="data"></router-view>

                <div class="page-load" v-show="data_status == 'loading'">
                    <div class="inline" valign="center">
                        <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                    </div>
                </div>

                <div class="submit button _free" v-show="showButton" @click="update()">Сохранить</div>

            </div>

        </div>
        <Rollback v-if="popup.active == 'rollback'" :data.sync="popup" @rollbackSuccess="rollbackSuccess()"></Rollback>

    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Rollback from '@/components/Rollback.vue'

    import popups from '@/mixins/popups'

    export default {
        mixins: [popups],
        components: {
            Header,
            Rollback
        },
        data () {
          return {
              data: {},
              data_backup: {},
              data_status: 'init',
              status_request: 'init',
          }
        },
        created () {
            this.getData()
        },
        computed: {
            showButton () {
                if (JSON.stringify(this.data) == this.data_backup || this.data_status != '') {
                    return false
                }
                return true
            }
        },
        methods: {
            rollbackSuccess () {
                this.data.rollback_possible = false
                this.savedata()
            },
            savedata () {
                this.data_backup = JSON.stringify(this.data)
            },
            update () {
                let json = JSON.stringify(this.data)
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/booking_request/' + this.$route.params.id, json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(() => {
                        this.status_request = ''
                        this.savedata()
                        let msg = {
                            message: 'Данные обновлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.status_request = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            reject () {
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/booking_request/' + this.$route.params.id + '/reject')
                        .then(() => {
                            this.status_request = ''
                            this.data.booking.rejected = true
                            this.data.booking.approved = false
                            this.savedata()
                            resolve()
                        })
                        .catch(() => {
                            this.status_request = ''
                            let msg = {
                                message: 'Ошибка при изменении статуса',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            approve () {
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/booking_request/' + this.$route.params.id + '/approve')
                        .then((resp) => {
                            if (resp.data.status) {
                                this.data.booking.approved = true
                                this.data.booking.rejected = false
                                this.savedata()
                            } else {
                                let msg = {
                                    message: resp.data.errors[0][1],
                                    status: 'error'
                                }
                                this.$store.dispatch('utils/showMessage', msg)
                            }
                            this.status_request = ''
                            resolve()
                        })
                        .catch(() => {
                            this.status_request = ''
                            let msg = {
                                message: 'Ошибка при изменении статуса',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            getData () {
                return new Promise((resolve) => {
                    this.data_status = 'loading'
                    this.axios.get('api/admin/v2/booking_request/' + this.$route.params.id)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.data_status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/booking_request')
                        })
                })
            }
        }
    }
</script>
